import { useEffect, useReducer } from 'react';

// Tope de setTimeout (2^31 - 1 ms, unos 24,8 días): por encima dispara al momento.
const MAX_ESPERA_MS = 2147483647;

// ¿Está cerrada la ventana de 24 h de WhatsApp? `cierre` es el instante que da
// `cierreVentanaWhatsApp` (null si no aplica). Con el chat abierto nada provoca
// un render al cumplirse las 24 h, así que se programa uno para ese instante.
// El temporizador se limpia al desmontar, al cambiar de chat o al moverse el
// cierre (llega un entrante nuevo).
function useVentanaCerrada(cierre, claveChat) {
  const [, repintar] = useReducer((n) => n + 1, 0);

  useEffect(() => {
    if (cierre == null) return undefined;
    const falta = cierre - Date.now();
    // Ya cerrada (incluido -Infinity): no hay nada que esperar.
    if (!(falta >= 0)) return undefined;
    const temporizador = setTimeout(repintar, Math.min(falta + 1, MAX_ESPERA_MS));
    return () => clearTimeout(temporizador);
  }, [cierre, claveChat]);

  return cierre != null && Date.now() > cierre;
}

export default useVentanaCerrada;
